export const GET_VIDEOS = 'app/Videos/GET_VIDEOS';
export const GET_EXPIRING_VIDEOS = 'app/Videos/GET_EXPIRING_VIDEOS';
export const GET_TRAILER = 'app/Videos/GET_TRAILER';
export const GET_FILTERED_VIDEOS = 'app/Videos/GET_FILTERED_VIDEOS';
export const GET_MEDIA_VIDEO = 'app/Videos/GET_MEDIA_VIDEO';
export const GET_PRODUCTION_VIDEO = 'app/Videos/GET_PRODUCTION_VIDEO';
export const GET_AND_RESET_FILTERED_VIDEOS = 'app/Videos/GET_AND_RESET_FILTERED_VIDEOS';
export const GET_AND_RESET_VIDEOS = 'app/Videos/GET_AND_RESET_VIDEOS';
export const MEDIA_ORDER = 'app/Videos/MEDIA_ORDER';
